import _ from 'lodash'
import { applyDefaults } from 'lib/utils'

const filterNull = (obj) => (
  Object.keys(obj)
    .filter(k => obj[k] !== null)
    .reduce((newObj, k) => { newObj[k] = obj[k]; return newObj }, {})
)

export const buildQueryString = (params) => (
  _.map(filterNull(params), (v, k) => [k, v].map(encodeURIComponent).join('=')).join('&')
)

const trips = {
  show: (id, privacyCode) => privacyCode ? `/trips/${id}?privacy_code=${privacyCode}` : `/trips/${id}`,
  edit: (id) => `/trips/${id}/edit`
}

const routes = {
  show: (id, privacyCode) => privacyCode ? `/routes/${id}?privacy_code=${privacyCode}` : `/routes/${id}`,
  edit: (id) => `/routes/${id}/edit`
}

const collections = {
  show: (id, privacyCode) => privacyCode ? `/collections/${id}?privacy_code=${privacyCode}` : `/collections/${id}`
}

const ambassadorRoutes = {
  show: (id) => `/ambassador_routes/${id}`
}

const embeds = {
  new: (id, type, privacyCode = null) => `/embeds/new?${buildQueryString({ type, id, privacyCode })}`
}

const goals = {
  show: (id) => `/goals/${id}`
}

const events = {
  show: (slug) => `/events/${slug}`
}

const experiences = {
  edit: (id) => `/experiences/${id}/edit`
}

const gear = {
  show: id => `/gear/${id}`
}

const segments = {
  show: slug => `/segments/${slug}`
}

const users = {
  show: (id) => `/users/${id}`,
  profileDefault: {
    small: id => `/users/${id}/profile-default-40.png`,
    small2x: id => `/users/${id}/profile-default-40@2x.png`,
    small3x: id => `/users/${id}/profile-default-40@3x.png`,
    large: id => `/users/${id}/profile-default-80.png`,
    large2x: id => `/users/${id}/profile-default-80@2x.png`,
    large3x: id => `/users/${id}/profile-default-80@3x.png`
  },
  liveLog: (id) => `/users/${id}/live_log`
}

const organizations = {
  show: slug => `/organizations/${slug}`,
  routes: slug => `/organizations/${slug}/routes`
}

const imgHelper = (size) => (id) => (id && id !== 0) ? `/photos/${id}/${size}.jpg` : `/images/${size}_no_image.png`

const getImgproxyUrl = (id, _params = {}) => {
  // see https://github.com/imgproxy/imgproxy/blob/master/docs/generating_the_url_basic.md
  // for full documentation on these options
  const defaultParams = {
    resizingType: 'fill',
    width: 100,
    height: 100,
    gravity: 'ce',
    enlarge: 1 // upscale images to match the requested size. Pass `enlarge: 0` to disable
  }
  const p = applyDefaults(defaultParams, _params)
  // final "0" is an ignored param, it just needs to be numeric but the server
  // doesn't do anything with it: https://rwgps.slack.com/archives/D1D1F8YSK/p1554828553015900
  return `/photos/${id}/${p.resizingType}/${p.width}/${p.height}/${p.gravity}/${p.enlarge}.jpg`
}

const photos = {
  nano: imgHelper('nano'),
  milli: imgHelper('milli'),
  centi: imgHelper('centi'),
  profile: imgHelper('profile'),
  sidebar: imgHelper('sidebar'),
  gear: imgHelper('gear'),
  medium: imgHelper('medium'),
  large: imgHelper('large'),
  full: imgHelper('full'),
  custom: getImgproxyUrl
}

const staticMap = (type, size, id) => (id && id !== 0) ? `/${type}s/${id}/${size}.png` : `/images/static_map_${size}_no_image.png`

export const urls = {
  trips,
  routes,
  collections,
  ambassadorRoutes,
  photos,
  embeds,
  goals,
  events,
  experiences,
  users,
  staticMap,
  gear,
  segments,
  organizations
}
